import { connectCustom } from "@client/lib/misc";
import { type AppState, type WithId } from "@client/types";
import { localStateSelector } from "../selectors";
import Component, { type MapProps } from "./component";

const makeMapStateToProps = () => {
  return (state: AppState, props: WithId): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,

      offers: localState.offers
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
